import { gql } from '@apollo/client'
import { buildUserSearchFilter } from '@ztechapps/common.utils'

//region GraphQL query
export const allCustomerListQuery = gql(`
  query customerList($filter: JSON, $options: JSON) {
    customerList(filter: $filter, options: $options) {
      _id
      profile {
        _id
        name
        email
        picture
      }
      status
      company {
        _id
        name
        domain
      }
    }
  }
`)

//endregion

export const useCustomerSelect = () => {
  const dataLoadOptions = ({ filter }: any) => ({
    query: allCustomerListQuery,
    filter: ({ input }: any) => ({
      ...buildUserSearchFilter(input),
      ...filter,
    }),
    options: () => ({
      sort: { 'company.name': 1 as const },
    }),
    resultFieldName: 'customerList',
  })

  return { dataLoadOptions }
}
